import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UpdatePayment from '../UpdatePayment';
import Success from '../Success';

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/success`} component={Success} />
      <Route path={path} component={UpdatePayment} />
    </Switch>
  );
};

export default Routes;
